import { PolicyActionEnum } from '@trinity/access-policy';
import { useCan } from '@trinity/access-policy/react';

/**
 * UI gating only: whether the user can mark a new good quote (the star, the highlight menu, or
 * saving a new moment with the Good Quote tag). chat-api requires `ie:transcript:mark-good-quotes`
 * for that, and a good quote is a tagged moment, so marking one also needs the tagged moment view
 * and create actions. Unmarking is not covered: that is a delete, see {@link useCanChangeGoodQuoteTag}.
 */
export const useCanMarkGoodQuotes = (): boolean =>
  useCan(
    PolicyActionEnum.IeTranscriptMarkGoodQuotes,
    PolicyActionEnum.IeTranscriptViewTaggedMoments,
    PolicyActionEnum.IeTranscriptCreateTaggedMoments
  );

/**
 * UI gating only: whether the user may set or clear the Good Quote tag on an existing tagged moment.
 * chat-api enforces `ie:transcript:mark-good-quotes` whenever that tag is added or removed, on top of
 * the edit or delete action the request itself needs, which the caller's own gating covers.
 */
export const useCanChangeGoodQuoteTag = (): boolean => useCan(PolicyActionEnum.IeTranscriptMarkGoodQuotes);
